var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page"},[_c('TopBar'),_vm._l((_vm.config),function(item,index){return [_c('img',{key:index,attrs:{"src":item.image}})]}),_c('FootBar')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }